"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Divider.css");

var _styles = {
  "horizontal": "Divider__horizontal___2sHaJ",
  "white": "Divider__white___DtuEW",
  "black": "Divider__black___sht19",
  "offwhite": "Divider__offwhite___wPBjy",
  "middle": "Divider__middle___8ZoPo",
  "no-bottom-margin": "Divider__no-bottom-margin___EkWRA"
};

const styles = _bind.default.bind(_styles);

const Divider = (0, _mobxReact.observer)(({
  className,
  variant,
  color,
  dataTestId,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('horizontal', variant, color), className);
  return _react.default.createElement("hr", {
    className: composed_classname,
    "data-testid": dataTestId,
    ...props
  });
});
Divider.defaultProps = {
  variant: 'full-width',
  color: 'default'
};
var _default = Divider;
exports.default = _default;